var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 4A2.75 2.75 0 017.5 1.25h9A2.75 2.75 0 0119.25 4v17.5h2a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5h2V4zM7.5 2.75c-.69 0-1.25.56-1.25 1.25v17.5h11.5V4c0-.69-.56-1.25-1.25-1.25h-9z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoom);
export default __webpack_public_path__ + "static/media/MeetingRoom.845858a23c5ceeed66fd50faf5902648.svg";
export { ForwardRef as ReactComponent };